module.exports = __webpack_public_path__ + "media/images/img-test-complete-f16c10cbf2446f288f44a0191d902413.svg";